<template>
  <a-layout id="layout">
    <a-layout-header class="header">
      <div><img class="logo" src="../../assets/logo.png" /></div>
      <a-menu
        theme="dark"
        mode="horizontal"
        :selectedKeys="selectedMenu"
        :style="{ lineHeight: '64px' }"
      >
        <a-menu-item key="instances">
          <router-link to="/instances" custom>{{
            titles.companyListing
          }}</router-link>
        </a-menu-item>

        <a-menu-item key="users">
          <router-link to="/users" custom>{{ titles.users }}</router-link>
        </a-menu-item>

        <a-menu-item key="sales">
          <router-link to="/sales" custom>{{ titles.sales }}</router-link>
        </a-menu-item>

        <a-menu-item key="plans">
          <router-link to="/plans" custom>{{ titles.plans }}</router-link>
        </a-menu-item>
        <a-menu-item key="addons">
            <router-link to="/addons" custom>{{ titles.addons }}</router-link>
		</a-menu-item>

        <a-menu-item key="channels">
          <router-link to="/channels" custom>{{ titles.channels }}</router-link>
        </a-menu-item>
      <a-menu-item key="accountHandler">
          <router-link to="/accountHandler" custom>{{ titles.accountHandler }}</router-link>
        </a-menu-item>
        <a-menu-item key="instanceManager">
          <router-link to="/instanceManager" custom>{{ titles.instanceManager }}</router-link>
        </a-menu-item>

        <a-menu-item key="instanceAppSetting">
          <router-link to="/instanceAppSetting" custom>{{ titles.instanceAppSetting }}</router-link>
        </a-menu-item>

        <a-sub-menu class="float-right">
          <span slot="title" class="submenu-title-wrapper"
            ><a-icon type="user" style="font-size: 23px; color: white"
          /></span>
          <a-menu-item key="ResetPassword">
            <a key="1" @click="isResetPasswordVisible = true"
              ><a-icon
                type="safety"
                style="font-size: 23px; color: white"
              />Reset Password</a
            >
          </a-menu-item>
          <a-menu-item key="logout">
            <router-link
              v-if="isAuthenticated"
              to="/login"
              v-on:click.native="logout()"
              replace
              ><a-icon
                type="logout"
                style="font-size: 23px; color: white"
              />Logout</router-link
            >
          </a-menu-item>
        </a-sub-menu>
      </a-menu>
    </a-layout-header>
    <a-layout class="main-layout">
      <a-layout class="content-container">
        <a-layout-content class="layout-content-container">
          <router-view />
          <ResetUserPassword
            v-model="isResetPasswordVisible"
          ></ResetUserPassword>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
</template>
<script>
import ResetUserPassword from "../Users/ResetUserPassword";

export default {
  data() {
    return {
      isResetPasswordVisible: false,
      collapsed: false,
      titles: {
        companyListing: "Company Listing",
        users: "Users",
        plans: "Plans",
        channels: "Channels",
        instanceManager: "Instance Manager",
        instanceAppSetting: "Instance App Settings",
        addons: "Addons",
        accountHandler: "Account Handlers",
        sales: "Sales",
      },
    };
  },
  methods: {
    logout() {
      this.$logoutUser();
    },
  },
  computed: {
    isAuthenticated() {
      return this.$authenticationInfo.isAuthenticated;
    },
        
    selectedMenu() {
      const self = this;
      return [self.$route.name && self.$route.name !== "default"
          ? self.$route.name
          : self.$landingPage];
    },
  },
  components: {
    ResetUserPassword,
  },
};
</script>

<style lang="scss" scoped>
.logo {
	max-width: 40px;
	margin: 12px 25px 12px 0;
	float: left;
}

.main-layout {
	height: calc(100vh - 110px);
	overflow-y: auto;

	.layout-content-container {
		background-color: #fff;
		padding: 15px;
		margin: 0px;
		min-height: calc(100% - 10px);
	}

  .content-container {
    max-width: 90vw;
    min-width: calc(max(70vw, 980px));
    margin: 10px auto;
  }
}
</style>
